import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "MainPageBackground" }
const _hoisted_2 = { class: "TopBar" }
const _hoisted_3 = { class: "TopBarContent" }
const _hoisted_4 = { class: "Logo" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "home-particles" }
const _hoisted_7 = {
  id: "section-1",
  class: "full-page-section content-section"
}
const _hoisted_8 = { class: "decorative-sidebar" }
const _hoisted_9 = { class: "product-left" }
const _hoisted_10 = { class: "product-image-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "product-right" }
const _hoisted_13 = { class: "game-title" }
const _hoisted_14 = { class: "game-subtitle" }
const _hoisted_15 = { class: "game-desc" }
const _hoisted_16 = { class: "highlight" }
const _hoisted_17 = { class: "game-list-sidebar" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["src"]
const _hoisted_20 = {
  key: 0,
  class: "info-boxes-wrapper"
}
const _hoisted_21 = {
  key: 1,
  class: "info-boxes-wrapper empty-announcement"
}
const _hoisted_22 = { class: "about-panel-container" }
const _hoisted_23 = { class: "about-navigation" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "card-num" }
const _hoisted_26 = { class: "card-title-group" }
const _hoisted_27 = { class: "card-title" }
const _hoisted_28 = { class: "card-subtitle" }
const _hoisted_29 = { class: "about-details-content" }
const _hoisted_30 = { class: "viewport-main-title" }
const _hoisted_31 = { class: "row-header" }
const _hoisted_32 = { class: "row-title" }
const _hoisted_33 = { class: "row-description" }
const _hoisted_34 = {
  key: 0,
  class: "all-list-overlay"
}
const _hoisted_35 = { class: "all-list-box" }
const _hoisted_36 = { class: "all-list-scroll" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "simple-info" }

import { ref, watch, onMounted, onUnmounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router"; // Add router imports
import useGlobalStateStore, { Enum_Theme } from "@/Store/GlobalStateStore";
import InfoBox_Left from "@/components/InfoBox_Left.vue";
import AnnouncementModal from "@/components/AnnouncementModal.vue";
import { AnOutlinedBilibili, AnOutlinedX, MdEmail, SiSinaweibo, CoBrandYoutube, AnOutlinedClose } from "@kalimahapps/vue-icons";
import { fetchAnnouncements } from "@/server/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainPage_EN',
  setup(__props) {

_useCssVars(_ctx => ({
  "c6bd92c6": (ThemeTopBarBackgroundColor.value),
  "v4277c12d": (activeSection.value === 0 ? "none" : "0 2px 4px rgba(0, 0, 0, 0.15)"),
  "v6d60092b": (ThemeTopBarColor.value),
  "v6700c994": (ThemeItemColor.value),
  "accf7f7c": (ThemeHintColor.value),
  "v725f10c0": (ThemeMainSloganCruxColor.value),
  "v50e76f52": (ThemeMainSloganColor.value),
  "v363e1b64": (ThemeSubSlogan.value),
  "v0bdfdcf0": (ThemeIconBackgroundHoverColor.value),
  "v4430386c": (ThemeBottomBG.value),
  "v37a6c19e": (ThemeBottomPartingLine.value),
  "c3a97ef4": (ThemeCopyrightFiling.value)
}))

const GlobalStyleStore = useGlobalStateStore();
const activeSection = ref(0);
const scrollContainer = ref<HTMLElement | null>(null);

const route = useRoute();
const router = useRouter();

const isModalVisible = ref(false);
const currentAnnouncementData = ref<any>(null);

function openAnnouncementModal(item: any) {
  currentAnnouncementData.value = item;
  isModalVisible.value = true;

  // Sync the news ID to the URL
  router.replace({ query: { ...route.query, news_id: item.id } });
}

function closeAnnouncementModal() {
  isModalVisible.value = false;

  // Remove the news_id param from the URL
  const currentQuery = { ...route.query };
  delete currentQuery.news_id;
  router.replace({ query: currentQuery });
}

const ThemeTopBarBackgroundColor = ref("transparent");
const ThemeTopBarColor = ref("#fff");
const ThemeItemColor = ref("#57E1D9");
const ThemeMainSloganColor = ref("#FFF");
const ThemeMainSloganCruxColor = ref("#57E1D9");
const ThemeSubSlogan = ref("#FFF");
const ThemeIconBackgroundColor = ref("#3fb7b0");
const ThemeIconBackgroundHoverColor = ref("#57E1D9");
const ThemeBottomBG = ref("#242424");
const ThemeBottomPartingLine = ref("#FFFFFF26");
const ThemeCopyrightFiling = ref("#FFF");
const ThemeHintColor = ref("#FFF");

// --- Home 3D Parallax Logic ---
const mouseX = ref(0);
const mouseY = ref(0);
const isHoveringHome = ref(false);

function onHomeMouseMove(e: MouseEvent) {
  isHoveringHome.value = true;
  const { innerWidth, innerHeight } = window;
  mouseX.value = (e.clientX / innerWidth - 0.5) * 2;
  mouseY.value = (e.clientY / innerHeight - 0.5) * 2;
}

function onHomeMouseLeave() {
  isHoveringHome.value = false;
  mouseX.value = 0;
  mouseY.value = 0;
}

const homeBgLayers = computed(() => {
  const moveX = mouseX.value;
  const moveY = mouseY.value;

  const config = [
    { mult: 0.4, scale: 1.02, opacity: 0.35, blur: '6px', blend: 'normal', hue: 0 },
    { mult: 0.8, scale: 1.06, opacity: 0.50, blur: '3px', blend: 'normal', hue: 15 },
    { mult: 1.3, scale: 1.10, opacity: 0.90, blur: '0px', blend: 'normal', hue: 0 },
    { mult: 2.0, scale: 1.16, opacity: 0.40, blur: '2px', blend: 'screen', hue: -15 },
    { mult: 2.8, scale: 1.25, opacity: 0.25, blur: '10px', blend: 'color-dodge', hue: 30 }
  ];

  return config.map((layer, index) => {
    const x = moveX * layer.mult * 1.5;
    const y = moveY * layer.mult * 1.5;
    return {
      transform: `scale(${layer.scale}) translate(${-x}%, ${-y}%)`,
      transition: isHoveringHome.value ? 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'transform 2.5s ease-out',
      backgroundImage: "url('/Images/HomeBG.jpg')",
      opacity: layer.opacity,
      filter: `blur(${layer.blur}) hue-rotate(${layer.hue}deg)`,
      mixBlendMode: layer.blend as any,
      zIndex: index + 1
    };
  });
});

// --- Section 3: "About Us" Data (English Translated) ---
const activeAboutTab = ref(0);
const aboutTabsData = [
  {
    num: "01",
    title: "General",
    subTitle: "GENERAL",
    paragraphs: [
      { label: "Company Profile", desc: "Founded in 2021, LESJEUXA is a next-generation game creative company. Built on the pillars of \"Technology R&D, Art Creation, and New Culture Communication,\" we are committed to providing outstanding and innovative \"Lesjeuxa Solutions\" for Asia and the world." },
      { label: "Purpose & Mission", desc: "Purpose: Supported by cutting-edge technology, we stimulate cultural vitality through artistic creativity, promoting cross-border integration of the gaming industry and cultural exchange.\nMission: We drive product development with technological innovation, convey human values through artistic expression, and disseminate globally influential new culture via digital media and multi-platform networks." },
      { label: "Vision", desc: "To continuously emerge as a pioneering enterprise leading global game creativity and cultural communication in every new era, achieving a perfect blend of technology and art, building an open, shared, and co-creative digital ecosystem, and fulfilling humanity's dream of a true metaverse and digital life." }
    ]
  },
  {
    num: "02",
    title: "Creed",
    subTitle: "CREED",
    paragraphs: [
      { label: "Technology R&D", desc: "We adhere to technology as our guide, constantly exploring new technologies and methods. We strive for breakthroughs in areas like AI, blockchain, and virtual reality to drive innovation in gaming and the metaverse. We focus on the commercialization and practical application of R&D results to provide safe, smooth, and innovative \"Lesjeuxa Concepts\" to global users." },
      { label: "Art Creation", desc: "We respect artistic diversity, stimulate creative potential, and encourage cross-border collaboration to integrate traditional culture with modern art and game design. Upholding the spirit of originality, we craft uniquely styled game worlds and visual expressions to deliver a distinctive aesthetic experience." },
      { label: "New Culture Communication", desc: "With an open and inclusive attitude, we promote cultural exchange by disseminating new cultural concepts that align with the spirit of the times. Leveraging digital media and social networks, we enable global users to share high-quality cultural content and innovative experiences." }
    ]
  },
  {
    num: "03",
    title: "Action & Mgmt",
    subTitle: "ACTION",
    paragraphs: [
      { label: "Innovation-Driven", desc: "We establish interdisciplinary, cross-domain creative teams to encourage deep integration of technology and art, crafting game products and cultural projects that align with future trends. We are enthusiastic about all forms of creative exchanges and industry seminars to inspire team creativity and collaborative spirit." },
      { label: "Institutional Guarantee", desc: "Our project management is executed in accordance with rules drafted based on the common law system, the most transparent system in human history. We establish comprehensive standards for R&D, creation, and communication to ensure efficient and standardized operations. We set up incentive and feedback mechanisms to encourage members to innovate and excel, creating a positive corporate culture." },
      { label: "Market & Cooperation", desc: "We actively expand and study domestic and international markets, building strategic partnerships, and joining hands with excellent enterprises and institutions to enter Gaming 2.0. We place great emphasis on brand building, creating a leading global image for Lesjeuxa in gaming culture and the metaverse through continuous innovation and premium service." }
    ]
  }
];

watch(() => [GlobalStyleStore.CurrentTheme, activeSection.value], () => {
  const isDark = GlobalStyleStore.CurrentTheme === Enum_Theme.Dark;
  const isHome = activeSection.value === 0;

  ThemeTopBarBackgroundColor.value = isHome ? 'transparent' : (isDark ? 'rgba(28, 28, 28, 0.57)' : 'rgba(255, 255, 255, 0.57)');
  ThemeTopBarColor.value = isDark ? '#fff' : '#484848';
  ThemeItemColor.value = isDark ? '#57E1D9' : '#f77373';

  if (isDark) {
    ThemeMainSloganColor.value = '#FFF';
    ThemeMainSloganCruxColor.value = '#57E1D9';
    ThemeSubSlogan.value = '#FFF';
    ThemeIconBackgroundColor.value = '#3fb7b0';
    ThemeIconBackgroundHoverColor.value = '#57E1D9';
    ThemeBottomBG.value = '#242424';
    ThemeBottomPartingLine.value = '#FFFFFF26';
    ThemeCopyrightFiling.value = 'rgba(255,255,255,0.6)';
    ThemeHintColor.value = 'rgba(255,255,255,0.6)';
  } else {
    ThemeMainSloganColor.value = '#545454';
    ThemeMainSloganCruxColor.value = '#f77373';
    ThemeSubSlogan.value = '#1a1a1a';
    ThemeIconBackgroundColor.value = '#de5959';
    ThemeIconBackgroundHoverColor.value = '#f77373';
    ThemeBottomBG.value = '#efefef';
    ThemeBottomPartingLine.value = 'rgba(185,185,185,0.1)';
    ThemeCopyrightFiling.value = 'rgba(0,0,0,0.6)';
    ThemeHintColor.value = 'rgba(0,0,0,0.6)';
  }
}, { immediate: true });

function scrollToSection(index: number) {
  if (scrollContainer.value) {
    const section = scrollContainer.value.querySelector(`#section-${index}`);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

let observer: IntersectionObserver | null = null;
const allAnnouncements = ref<any[]>([]);
const topAnnouncements = ref<any[]>([]);

onMounted(async () => {
  const options = { root: scrollContainer.value, rootMargin: '0px', threshold: 0.5 };
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const idParts = entry.target.id.split('-');
        if (idParts.length === 2) {
          activeSection.value = parseInt(idParts[1]);
        }
      }
    });
  }, options);
  document.querySelectorAll('.full-page-section').forEach(sec => observer?.observe(sec));

  const rawData = await fetchAnnouncements();
  const enList: any[] = [];

  rawData.forEach((item: any) => {
    try {
      // NOTE: 解析后端 JSON 数据时，提取对应的 .en 字段
      const titles = item.title.startsWith('{') ? JSON.parse(item.title) : { en: item.title };
      const summaries = item.summary.startsWith('{') ? JSON.parse(item.summary) : { en: item.summary };
      const contents = item.content.startsWith('{') ? JSON.parse(item.content) : { en: item.content };
      const authors = item.author && item.author.startsWith('{') ? JSON.parse(item.author) : { en: item.author || '' };

      if(titles.en) {
        enList.push({
          ...item,
          title: titles.en,
          summary: summaries.en || '',
          author: authors.en || '',
          content: contents.en || ''
        });
      }
    } catch(error) {
      console.warn("JSON parsing failed, possible dirty data", error);
    }
  });

  allAnnouncements.value = enList;
  topAnnouncements.value = enList.slice(0, 3);

  // Check URL parameters for direct link to news
  const newsId = route.query.news_id;
  if (newsId) {
    const targetNews = allAnnouncements.value.find(item => String(item.id) === String(newsId));
    if (targetNews) {
      // Delay to ensure DOM is mounted, then scroll and open modal
      setTimeout(() => {
        activeSection.value = 2; // Force active state on Navigation
        scrollToSection(2);      // Scroll down to News Section
        openAnnouncementModal(targetNews);
      }, 500);
    }
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

const isAllListModalVisible = ref(false);

const gameList = ref([
  {
    id: 1,
    titleCHS: 'Star Reverie · Greystasis',
    titleEN: '',
    desc: [
      'As Greystasis spreads and Oneiroth Syndrome runs rampant, humanity’s sanctuary is rapidly collapsing.',
      'By a twist of fate, the protagonist joins Nyctophoros and becomes a Covenant Keeper. While working with companions to resolve crises, help others, and uncover the truth of their own origins, they quietly draw closer to the secrets of the world.',
      'However, when the Dream Source—once a symbol of hope—is tainted by crimson, and nightmares engulf reality like a rising tide, time is running out. The vessel bearing fate and dreams teeters on the verge of shattering, and the blood of the gods will finally pour upon the mortal world...'
    ],
    highlight: 'Reboot, or reach the end.',
    kvPath: '/Images/Games/Star Reverie/StarReverieKV.png',
    iconPath: '/Images/Games/Star Reverie/StarReverieIcon.png'
  }
]);
const currentGameIndex = ref(0);

function OnUserClickLogo() {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark) {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Light);
  } else {
    GlobalStyleStore.SetCurrentTheme(Enum_Theme.Dark);
  }
}

async function OnCLickEmail() {
  try {
    await navigator.clipboard.writeText("info@lesjeuxa.com");
    alert("Email address copied to clipboard. We look forward to hearing from you! (๑′ᴗ‵๑)❤");
  } catch (error) {
    console.error("Failed to copy", error);
  }
}

function OnCLickX() {
  window.open("https://x.com", "_blank");
}

function OnCLickWeiBo() {
  window.open("https://weibo.com/", "_blank");
}

function OnCLickBilibili() {
  window.open("https://www.bilibili.com/", "_blank");
}

function OnCLickYoutuber() {
  window.open("https://www.youtube.com/@lesjeuxa", "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Dark)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: "/Images/Logo.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true),
          (_unref(GlobalStyleStore).CurrentTheme===_unref(Enum_Theme).Light)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: "/Images/Logo_1.png",
                alt: "Logo",
                onClick: OnUserClickLogo
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["NavBar", { 'hide-on-home': activeSection.value === 0 }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Home', 'Products', 'News', 'About Us', 'Join Us'], (item, index) => {
            return _createElementVNode("span", {
              key: index,
              class: _normalizeClass(["nav-item", { active: activeSection.value === index }]),
              onClick: ($event: any) => (scrollToSection(index))
            }, _toDisplayString(item), 11, _hoisted_5)
          }), 64))
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["Login", { 'hide-on-home': activeSection.value === 0 }])
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("span", { class: "item" }, "Register", -1),
          _createElementVNode("span", { class: "separator" }, "|", -1),
          _createElementVNode("span", { class: "item" }, "Login", -1)
        ]))], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: "ScrollContainer",
      ref_key: "scrollContainer",
      ref: scrollContainer
    }, [
      _createElementVNode("section", {
        id: "section-0",
        class: "full-page-section home-section",
        onMousemove: onHomeMouseMove,
        onMouseleave: onHomeMouseLeave
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(homeBgLayers.value, (layerStyle, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            class: "home-parallax-bg",
            style: _normalizeStyle(layerStyle)
          }, null, 4))
        }), 128)),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "home-vignette-overlay" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(60, (n) => {
            return _createElementVNode("div", {
              class: "particle",
              key: n
            })
          }), 64))
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "overlay",
          style: {"z-index":"10"}
        }, null, -1)),
        _createElementVNode("div", {
          class: "scroll-hint",
          style: {"z-index":"11","cursor":"pointer"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollToSection(1)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("p", null, "Scroll down for more", -1),
          _createElementVNode("div", { class: "arrow-down" }, null, -1)
        ]))])
      ], 32),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(["product-container", { 'is-active': activeSection.value === 1 }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(gameList.value[currentGameIndex.value].titleEN.toUpperCase()) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dot" }, null, -1)),
            _cache[10] || (_cache[10] = _createTextVNode(" LESJEUXA", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(), _createElementBlock("img", {
                src: gameList.value[currentGameIndex.value].kvPath,
                class: "product-kv",
                key: currentGameIndex.value
              }, null, 8, _hoisted_11))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h1", _hoisted_13, _toDisplayString(gameList.value[currentGameIndex.value].titleCHS), 1),
            _createElementVNode("h3", _hoisted_14, _toDisplayString(gameList.value[currentGameIndex.value].titleEN), 1),
            _createElementVNode("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value[currentGameIndex.value].desc, (paragraph, i) => {
                return (_openBlock(), _createElementBlock("p", { key: i }, _toDisplayString(paragraph), 1))
              }), 128)),
              _createElementVNode("p", _hoisted_16, _toDisplayString(gameList.value[currentGameIndex.value].highlight), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(gameList.value, (game, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: game.id,
                class: _normalizeClass(["game-list-item", { 'is-selected': currentGameIndex.value === index }]),
                onClick: ($event: any) => (currentGameIndex.value = index)
              }, [
                _createElementVNode("img", {
                  src: game.iconPath
                }, null, 8, _hoisted_19)
              ], 10, _hoisted_18))
            }), 128))
          ])
        ], 2)
      ]),
      _createElementVNode("section", {
        id: "section-2",
        class: _normalizeClass(["full-page-section content-section", { 'is-active': activeSection.value === 2 }])
      }, [
        (topAnnouncements.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topAnnouncements.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "anim-item",
                  style: _normalizeStyle({ 'transition-delay': `${index * 0.2}s` })
                }, [
                  _createVNode(InfoBox_Left, {
                    Title: item.title,
                    Summary: item.summary,
                    ImagePath: item.cover_image,
                    onOpenModal: ($event: any) => (openAnnouncementModal(item))
                  }, null, 8, ["Title", "Summary", "ImagePath", "onOpenModal"])
                ], 4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("p", null, "No news updates", -1)
            ]))])),
        (allAnnouncements.value.length > 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: "more-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (isAllListModalVisible.value = true))
            }, [...(_cache[12] || (_cache[12] = [
              _createTextVNode(" More ", -1),
              _createElementVNode("span", null, "+", -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("section", {
        id: "section-3",
        class: _normalizeClass(["full-page-section content-section learn-us-section", { 'is-active': activeSection.value === 3 }])
      }, [
        _cache[16] || (_cache[16] = _createStaticVNode("<div class=\"about-header-slogan\" data-v-0f903a64><h1 class=\"brand-core-slogan\" data-v-0f903a64><span class=\"highlight-cyan\" data-v-0f903a64>Tech </span> R&amp;D • <span class=\"highlight-cyan\" data-v-0f903a64>Art</span> Creation • <span class=\"highlight-cyan\" data-v-0f903a64>New Culture</span> Communication </h1><p class=\"brand-core-desc\" data-v-0f903a64> LESJEUXA is always committed to the integration of cutting-edge technology and artistic aesthetics, providing outstanding &quot;Lesjeuxa Solutions&quot; for the digital era. </p></div>", 1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(aboutTabsData, (tab, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(["about-nav-card", { 'is-active': activeAboutTab.value === index }]),
                onClick: ($event: any) => (activeAboutTab.value = index)
              }, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(tab.num), 1),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("span", _hoisted_27, _toDisplayString(tab.title), 1),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(tab.subTitle), 1)
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("div", { class: "card-glow-bar" }, null, -1))
              ], 10, _hoisted_24)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_29, [
            (_openBlock(), _createElementBlock("div", {
              class: "details-viewport",
              key: activeAboutTab.value
            }, [
              _createElementVNode("h2", _hoisted_30, _toDisplayString(aboutTabsData[activeAboutTab.value].title) + " Outline", 1),
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "viewport-divider" }, null, -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aboutTabsData[activeAboutTab.value].paragraphs, (para, pIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pIdx,
                  class: "content-row",
                  style: _normalizeStyle({ 'animation-delay': `${pIdx * 0.15}s` })
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "row-indicator" }, null, -1)),
                    _createElementVNode("h4", _hoisted_32, _toDisplayString(para.label), 1)
                  ]),
                  _createElementVNode("p", _hoisted_33, _toDisplayString(para.desc), 1)
                ], 4))
              }), 128))
            ]))
          ])
        ])
      ], 2),
      _createElementVNode("section", {
        id: "section-4",
        class: "full-page-section end-section"
      }, [
        _createElementVNode("div", { class: "join-content" }, [
          _cache[18] || (_cache[18] = _createElementVNode("div", { class: "join-text-group" }, [
            _createElementVNode("h2", { class: "join-title" }, "JOIN US"),
            _createElementVNode("p", { class: "join-subtitle" }, "Looking forward to your talent to weave the next dream together with us.")
          ], -1)),
          _createElementVNode("div", {
            class: "contact-wrapper",
            onClick: OnCLickEmail
          }, [...(_cache[17] || (_cache[17] = [
            _createElementVNode("div", { class: "contact-label" }, "MAIL TO US", -1),
            _createElementVNode("div", { class: "contact-email" }, "info@lesjeuxa.com", -1),
            _createElementVNode("div", { class: "contact-hover-line" }, null, -1),
            _createElementVNode("div", { class: "contact-hint" }, "CLICK TO COPY EMAIL ADDRESS", -1)
          ]))])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "BottomBG" }, [
          _createElementVNode("div", { class: "BottomPartingLine" }),
          _createElementVNode("div", { class: "BottomContent" }, [
            _createElementVNode("div", { class: "CopyrightFiling" }, "Copyright 2021-2026 LESJEUXA.COM. All Rights Reserved.")
          ])
        ], -1))
      ])
    ], 512),
    _createVNode(AnnouncementModal, {
      visible: isModalVisible.value,
      announcement: currentAnnouncementData.value,
      onClose: closeAnnouncementModal
    }, null, 8, ["visible", "announcement"]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (isAllListModalVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  class: "close-btn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (isAllListModalVisible.value = false))
                }, [
                  _createVNode(_unref(AnOutlinedClose))
                ]),
                _cache[20] || (_cache[20] = _createElementVNode("h2", { style: {"color":"black","margin-bottom":"30px"} }, "All News", -1)),
                _createElementVNode("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allAnnouncements.value, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "simple-list-item",
                      key: item.id,
                      onClick: ($event: any) => (openAnnouncementModal(item))
                    }, [
                      _createElementVNode("img", {
                        src: item.cover_image,
                        class: "slim-cover"
                      }, null, 8, _hoisted_38),
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("h3", null, _toDisplayString(item.title), 1),
                        _createElementVNode("p", null, _toDisplayString(item.summary), 1)
                      ])
                    ], 8, _hoisted_37))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", {
      class: "global-scroll-hint",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (scrollToSection(activeSection.value + 1)))
    }, [...(_cache[21] || (_cache[21] = [
      _createElementVNode("div", { class: "arrow-down" }, null, -1)
    ]))], 512), [
      [_vShow, activeSection.value > 0 && activeSection.value < 4]
    ])
  ]))
}
}

})